module.exports = __webpack_public_path__ + "img/c00_buildingtechscalemailandhidearmor_Normal_ua.6008c55b.webp";